import React from 'react';
import './ComparisonSection.css';

const ComparisonSection = () => {
  return (
    <div className="comparison-section">
      <div className="container">
        <h2>How Bounce Compares</h2>
        <p className="comparison-subtitle">See why businesses choose Bounce over traditional solutions</p>
        
        <div className="comparison-table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th className="feature-col">Feature</th>
                <th className="bounce-col">
                  <div className="company-header">
                    <strong>Bounce Loyalty</strong>
                    <span className="company-badge">Our Solution</span>
                  </div>
                </th>
                <th>Square Loyalty</th>
                <th>Stamp Me</th>
                <th>Traditional Punch Cards</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="feature-name">Monthly Cost (500 customers)</td>
                <td className="bounce-feature"><span className="icon-good">✓</span> $0 CAD</td>
                <td><span className="icon-bad">✗</span> $83 CAD</td>
                <td><span className="icon-bad">✗</span> $67 CAD</td>
                <td><span className="icon-limited">⚠</span> $0 (but no features)</td>
              </tr>
              <tr>
                <td className="feature-name">Customer Friction</td>
                <td className="bounce-feature"><span className="icon-good">✓</span> Just tap phone</td>
                <td><span className="icon-bad">✗</span> Manual email entry required</td>
                <td><span className="icon-bad">✗</span> App download required</td>
                <td><span className="icon-bad">✗</span> Physical cards get lost</td>
              </tr>
              <tr>
                <td className="feature-name">Custom Branding</td>
                <td className="bounce-feature"><span className="icon-good">✓</span> Full customization</td>
                <td><span className="icon-bad">✗</span> None</td>
                <td><span className="icon-limited">⚠</span> Basic customization</td>
                <td><span className="icon-good">✓</span> Full control (design cost)</td>
              </tr>
              <tr>
                <td className="feature-name">Marketing Tools</td>
                <td className="bounce-feature"><span className="icon-good">✓</span> Built-in campaigns</td>
                <td><span className="icon-limited">⚠</span> Basic email features</td>
                <td><span className="icon-good">✓</span> Built-in campaigns</td>
                <td><span className="icon-bad">✗</span> None</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ComparisonSection;






